import React from "react";
export default function CustomSetting() {
  return (
    <>
      <div
        className="offcanvas offcanvas-end live-customizer"
        tabIndex={-1}
        id="live-customizer"
        data-bs-scroll="true"
        data-bs-backdrop="false"
        aria-labelledby="live-customizer-label"
      >
        <div className="offcanvas-header">
          <div className="d-flex align-items-center">
            <h4 className="offcanvas-title" id="live-customizer-label">
              Live Customizer
            </h4>
          </div>
          <div className="d-flex gap-2 align-items-center">
            <button
              className="btn btn-primary btn-icon"
              data-reset="settings"
              data-bs-toggle="tooltip"
              data-bs-placement="left"
              title="Reset All Settings"
            >
              <span className="btn-inner">
                <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.4">
                    <path
                      d="M4.88076 14.6713C4.74978 14.2784 4.32504 14.066 3.93208 14.197C3.53912 14.328 3.32675 14.7527 3.45774 15.1457L4.88076 14.6713ZM20.8808 15.1457C21.0117 14.7527 20.7994 14.328 20.4064 14.197C20.0135 14.066 19.5887 14.2784 19.4577 14.6713L20.8808 15.1457ZM4.16925 14.9085C3.45774 15.1457 3.45785 15.146 3.45797 15.1464C3.45802 15.1465 3.45815 15.1469 3.45825 15.1472C3.45845 15.1478 3.45868 15.1485 3.45895 15.1493C3.45948 15.1509 3.46013 15.1528 3.46092 15.1551C3.46249 15.1597 3.46456 15.1657 3.46716 15.1731C3.47235 15.188 3.47961 15.2084 3.48902 15.2341C3.50782 15.2854 3.53521 15.3576 3.5717 15.4477C3.64461 15.6279 3.7542 15.8805 3.90468 16.1814C4.2048 16.7817 4.67223 17.5836 5.34308 18.3886C6.68942 20.0043 8.88343 21.6585 12.1693 21.6585V20.1585C9.45507 20.1585 7.64908 18.8128 6.49542 17.4284C5.91627 16.7334 5.5087 16.0354 5.24632 15.5106C5.11555 15.2491 5.02201 15.0329 4.96212 14.8849C4.9322 14.811 4.91076 14.7543 4.89733 14.7177C4.89062 14.6994 4.88593 14.6861 4.88318 14.6783C4.88181 14.6744 4.88093 14.6718 4.88053 14.6706C4.88033 14.67 4.88025 14.6698 4.88029 14.6699C4.88031 14.67 4.88036 14.6701 4.88044 14.6704C4.88047 14.6705 4.88056 14.6707 4.88058 14.6708C4.88067 14.671 4.88076 14.6713 4.16925 14.9085ZM12.1693 21.6585C15.4551 21.6585 17.6491 20.0043 18.9954 18.3886C19.6663 17.5836 20.1337 16.7817 20.4338 16.1814C20.5843 15.8805 20.6939 15.6279 20.7668 15.4477C20.8033 15.3576 20.8307 15.2854 20.8495 15.2341C20.8589 15.2084 20.8662 15.188 20.8713 15.1731C20.8739 15.1657 20.876 15.1597 20.8776 15.1551C20.8784 15.1528 20.879 15.1509 20.8796 15.1493C20.8798 15.1485 20.8801 15.1478 20.8803 15.1472C20.8804 15.1469 20.8805 15.1465 20.8805 15.1464C20.8807 15.146 20.8808 15.1457 20.1693 14.9085C19.4577 14.6713 19.4578 14.671 19.4579 14.6708C19.4579 14.6707 19.458 14.6705 19.4581 14.6704C19.4581 14.6701 19.4582 14.67 19.4582 14.6699C19.4583 14.6698 19.4582 14.67 19.458 14.6706C19.4576 14.6718 19.4567 14.6744 19.4553 14.6783C19.4526 14.6861 19.4479 14.6994 19.4412 14.7177C19.4277 14.7543 19.4063 14.811 19.3764 14.8849C19.3165 15.0329 19.223 15.2491 19.0922 15.5106C18.8298 16.0354 18.4222 16.7334 17.8431 17.4284C16.6894 18.8128 14.8834 20.1585 12.1693 20.1585V21.6585Z"
                      fill="currentColor"
                    />
                    <path
                      d="M21.5183 19.2271C21.4293 19.2234 21.3427 19.196 21.2671 19.1465L16.3546 15.8924C16.2197 15.8026 16.1413 15.6537 16.148 15.4969C16.1546 15.34 16.2452 15.1982 16.3873 15.1202L21.5571 12.2926C21.7075 12.2106 21.8932 12.213 22.0416 12.3003C22.1907 12.387 22.2783 12.5436 22.2712 12.7096L22.014 18.7913C22.007 18.9573 21.9065 19.1059 21.7506 19.1797C21.6772 19.215 21.597 19.2305 21.5183 19.2271"
                      fill="currentColor"
                    />
                  </g>
                  <path
                    d="M20.0742 10.0265C20.1886 10.4246 20.6041 10.6546 21.0022 10.5401C21.4003 10.4257 21.6302 10.0102 21.5158 9.61214L20.0742 10.0265ZM4.10803 8.88317C3.96071 9.27031 4.15513 9.70356 4.54226 9.85087C4.92939 9.99818 5.36265 9.80377 5.50996 9.41664L4.10803 8.88317ZM20.795 9.81934C21.5158 9.61214 21.5157 9.6118 21.5156 9.61144C21.5155 9.61129 21.5154 9.6109 21.5153 9.61059C21.5152 9.60998 21.515 9.60928 21.5147 9.60848C21.5143 9.60689 21.5137 9.60493 21.513 9.6026C21.5116 9.59795 21.5098 9.59184 21.5075 9.58431C21.503 9.56925 21.4966 9.54853 21.4882 9.52251C21.4716 9.47048 21.4473 9.39719 21.4146 9.3056C21.3493 9.12256 21.2503 8.8656 21.1126 8.55861C20.8378 7.94634 20.4044 7.12552 19.7678 6.29313C18.4902 4.62261 16.3673 2.87801 13.0844 2.74053L13.0216 4.23922C15.7334 4.35278 17.4816 5.77291 18.5763 7.20436C19.1258 7.92295 19.5038 8.63743 19.744 9.17271C19.8638 9.43949 19.9482 9.65937 20.0018 9.80972C20.0286 9.88483 20.0477 9.94238 20.0596 9.97951C20.0655 9.99808 20.0696 10.0115 20.072 10.0195C20.0732 10.0235 20.074 10.0261 20.0744 10.0273C20.0746 10.0278 20.0746 10.0281 20.0746 10.028C20.0746 10.0279 20.0745 10.0278 20.0745 10.0275C20.0744 10.0274 20.0744 10.0272 20.0743 10.0271C20.0743 10.0268 20.0742 10.0265 20.795 9.81934ZM13.0844 2.74053C9.80146 2.60306 7.54016 4.16407 6.12741 5.72193C5.42345 6.49818 4.92288 7.27989 4.59791 7.86704C4.43497 8.16144 4.31491 8.40923 4.23452 8.58617C4.1943 8.67471 4.16391 8.7457 4.14298 8.79616C4.13251 8.82139 4.1244 8.84151 4.11859 8.85613C4.11568 8.86344 4.11336 8.86938 4.1116 8.8739C4.11072 8.87616 4.10998 8.87807 4.10939 8.87962C4.10909 8.88039 4.10883 8.88108 4.1086 8.88167C4.10849 8.88196 4.10834 8.88234 4.10829 8.88249C4.10815 8.88284 4.10803 8.88317 4.80899 9.14991C5.50996 9.41664 5.50985 9.41692 5.50975 9.41719C5.50973 9.41725 5.50964 9.41749 5.50959 9.4176C5.5095 9.41784 5.50945 9.41798 5.50942 9.41804C5.50938 9.41816 5.50947 9.41792 5.50969 9.41734C5.51014 9.41619 5.51113 9.41365 5.51267 9.40979C5.51574 9.40206 5.52099 9.38901 5.52846 9.37101C5.5434 9.335 5.56719 9.27924 5.60018 9.20664C5.66621 9.0613 5.76871 8.84925 5.91031 8.59341C6.19442 8.08008 6.63084 7.39971 7.23855 6.72958C8.44912 5.39466 10.3098 4.12566 13.0216 4.23922L13.0844 2.74053Z"
                    fill="currentColor"
                  />
                  <path
                    d="M8.78337 9.33604C8.72981 9.40713 8.65805 9.46292 8.57443 9.49703L3.1072 11.6951C2.95672 11.7552 2.78966 11.7352 2.66427 11.6407C2.53887 11.5462 2.47359 11.3912 2.48993 11.2299L3.09576 5.36863C3.11367 5.19823 3.22102 5.04666 3.37711 4.97402C3.5331 4.9005 3.71173 4.91728 3.84442 5.01726L8.70581 8.68052C8.8385 8.78051 8.90387 8.94759 8.8762 9.1178C8.86358 9.19825 8.83082 9.27308 8.78337 9.33604"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </button>
          </div>
          <button
            type="button"
            className="btn-close px-0 text-reset shadow-none"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <div className="offcanvas-body data-scrollbar">
          <div className="row">
            <div className="col-lg-12">
              <div className="border border-2 rounded mb-3">
                <div className="px-3 pt-3 text-center">
                  <h5 className="d-inline-block">Style Setting</h5>
                </div>
                <div className="p-3">
                  {/* Theme start here */}
                  <div>
                    <h6 className="mb-3">Theme</h6>
                    <div className="d-grid gap-3 grid-cols-3 mb-3">
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="auto"
                          className="btn-check"
                          name="theme_scheme"
                          id="color-mode-auto"
                          defaultChecked=""
                        />
                        <label className="btn btn-border d-block" htmlFor="color-mode-auto">
                          <svg
                            className="icon-20"
                            width={20}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path fill="currentColor" d="M7,2V13H10V22L17,10H13L17,2H7Z" />
                          </svg>
                          Auto
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="dark"
                          className="btn-check"
                          name="theme_scheme"
                          id="color-mode-dark"
                        />
                        <label className="btn btn-border d-block" htmlFor="color-mode-dark">
                          <svg
                            className="icon-20"
                            width={20}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill="currentColor"
                              d="M9,2C7.95,2 6.95,2.16 6,2.46C10.06,3.73 13,7.5 13,12C13,16.5 10.06,20.27 6,21.54C6.95,21.84 7.95,22 9,22A10,10 0 0,0 19,12A10,10 0 0,0 9,2Z"
                            />
                          </svg>
                          Dark
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="light"
                          className="btn-check"
                          name="theme_scheme"
                          id="color-mode-light"
                        />
                        <label className="btn btn-border d-block" htmlFor="color-mode-light">
                          <svg
                            className="icon-20"
                            width={20}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill="currentColor"
                              d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8M12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z"
                            />
                          </svg>
                          Lightd
                        </label>
                      </div>
                    </div>
                    <div className="d-grid gap-3 grid-cols-2 mb-4">
                      <div data-setting="attribute" className="text-center">
                        <input
                          type="radio"
                          defaultValue="ltr"
                          className="btn-check"
                          name="theme_scheme_direction"
                          data-prop="dir"
                          id="theme-scheme-direction-ltr"
                          defaultChecked=""
                        />
                        <label className="btn btn-border d-block p-0" htmlFor="theme-scheme-direction-ltr">
                          <img
                            src="../assets/images/settings/dark/01.png"
                            alt="ltr"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/01.png"
                            alt="ltr"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2"> LTR </span>
                      </div>
                      <div data-setting="attribute" className="text-center">
                        <input
                          type="radio"
                          defaultValue="rtl"
                          className="btn-check"
                          name="theme_scheme_direction"
                          data-prop="dir"
                          id="theme-scheme-direction-rtl"
                        />
                        <label className="btn btn-border d-block p-0" htmlFor="theme-scheme-direction-rtl">
                          <img
                            src="../assets/images/settings/dark/02.png"
                            alt="ltr"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/02.png"
                            alt="ltr"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2"> RTL </span>
                      </div>
                    </div>
                  </div>
                  {/* Theme end here */}
                  <hr className="hr-horizontal" />
                  {/* Color customizer start here */}
                  <div>
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mt-4 mb-3">Color Customizer</h6>
                      <div className="d-flex align-items-center">
                        <a
                          href="#custom-color"
                          data-bs-toggle="collapse"
                          role="button"
                          aria-expanded="false"
                          aria-controls="custom-color"
                        >
                          Custom
                        </a>
                        <div data-setting="radio">
                          <input
                            type="radio"
                            defaultValue="theme-color-default"
                            className="btn-check"
                            name="theme_color"
                            id="theme-color-default"
                            data-colors='{"primary": "#3a57e8", "info": "#08B1BA"}'
                          />
                          <label
                            className="btn bg-transparent px-2 border-0"
                            htmlFor="theme-color-default"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Reset Color"
                            data-bs-original-title="Reset color"
                          >
                            <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M21.4799 12.2424C21.7557 12.2326 21.9886 12.4482 21.9852 12.7241C21.9595 14.8075 21.2975 16.8392 20.0799 18.5506C18.7652 20.3986 16.8748 21.7718 14.6964 22.4612C12.518 23.1505 10.1711 23.1183 8.01299 22.3694C5.85488 21.6205 4.00382 20.196 2.74167 18.3126C1.47952 16.4293 0.875433 14.1905 1.02139 11.937C1.16734 9.68346 2.05534 7.53876 3.55018 5.82945C5.04501 4.12014 7.06478 2.93987 9.30193 2.46835C11.5391 1.99683 13.8711 2.2599 15.9428 3.2175L16.7558 1.91838C16.9822 1.55679 17.5282 1.62643 17.6565 2.03324L18.8635 5.85986C18.945 6.11851 18.8055 6.39505 18.549 6.48314L14.6564 7.82007C14.2314 7.96603 13.8445 7.52091 14.0483 7.12042L14.6828 5.87345C13.1977 5.18699 11.526 4.9984 9.92231 5.33642C8.31859 5.67443 6.8707 6.52052 5.79911 7.74586C4.72753 8.97119 4.09095 10.5086 3.98633 12.1241C3.8817 13.7395 4.31474 15.3445 5.21953 16.6945C6.12431 18.0446 7.45126 19.0658 8.99832 19.6027C10.5454 20.1395 12.2278 20.1626 13.7894 19.6684C15.351 19.1743 16.7062 18.1899 17.6486 16.8652C18.4937 15.6773 18.9654 14.2742 19.0113 12.8307C19.0201 12.5545 19.2341 12.3223 19.5103 12.3125L21.4799 12.2424Z"
                                fill="#31BAF1"
                              />
                              <path
                                d="M20.0941 18.5594C21.3117 16.848 21.9736 14.8163 21.9993 12.7329C22.0027 12.4569 21.7699 12.2413 21.4941 12.2512L19.5244 12.3213C19.2482 12.3311 19.0342 12.5633 19.0254 12.8395C18.9796 14.283 18.5078 15.6861 17.6628 16.8739C16.7203 18.1986 15.3651 19.183 13.8035 19.6772C12.2419 20.1714 10.5595 20.1483 9.01246 19.6114C7.4654 19.0746 6.13845 18.0534 5.23367 16.7033C4.66562 15.8557 4.28352 14.9076 4.10367 13.9196C4.00935 18.0934 6.49194 21.37 10.008 22.6416C10.697 22.8908 11.4336 22.9852 12.1652 22.9465C13.075 22.8983 13.8508 22.742 14.7105 22.4699C16.8889 21.7805 18.7794 20.4073 20.0941 18.5594Z"
                                fill="#0169CA"
                              />
                            </svg>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="collapse" id="custom-color">
                      <div className="form-group d-flex justify-content-between align-items-center">
                        <label className="" htmlFor="custom-primary-color">
                          Primary
                        </label>
                        <input
                          className=""
                          name="theme_color"
                          data-extra="primary"
                          type="color"
                          id="custom-primary-color"
                          defaultValue="#3a57e8"
                          data-setting="color"
                        />
                      </div>
                      <div className="form-group d-flex d-flex justify-content-between align-items-center">
                        <label className="" htmlFor="custom-info-color">
                          Secondary
                        </label>
                        <input
                          className=""
                          name="theme_color"
                          data-extra="info"
                          type="color"
                          id="custom-info-color"
                          defaultValue="#08B1BA"
                          data-setting="color"
                        />
                      </div>
                    </div>
                    <div className="grid-cols-5 mb-4 d-grid gap-3">
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="theme-color-blue"
                          className="btn-check"
                          name="theme_color"
                          id="theme-color-1"
                          data-colors='{"primary": "#00C3F9", "info": "#573BFF"}'
                        />
                        <label
                          className="btn btn-border d-block bg-transparent"
                          htmlFor="theme-color-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Theme-1"
                          data-bs-original-title="Theme-1"
                        >
                          <svg
                            className="customizer-btn"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={26}
                            height={26}
                          >
                            <circle cx={12} cy={12} r={10} fill="#00C3F9" />
                            <path d="M2,12 a1,1 1 1,0 20,0" fill="#573BFF" />
                          </svg>
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="theme-color-gray"
                          className="btn-check"
                          name="theme_color"
                          id="theme-color-2"
                          data-colors='{"primary": "#91969E", "info": "#FD8D00"}'
                        />
                        <label
                          className="btn btn-border d-block bg-transparent"
                          htmlFor="theme-color-2"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Theme-2"
                          data-bs-original-title="Theme-2"
                        >
                          <svg
                            className="customizer-btn"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={26}
                            height={26}
                          >
                            <circle cx={12} cy={12} r={10} fill="#91969E" />
                            <path d="M2,12 a1,1 1 1,0 20,0" fill="#FD8D00" />
                          </svg>
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="theme-color-red"
                          className="btn-check"
                          name="theme_color"
                          id="theme-color-3"
                          data-colors='{"primary": "#DB5363", "info": "#366AF0"}'
                        />
                        <label
                          className="btn btn-border d-block bg-transparent"
                          htmlFor="theme-color-3"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Theme-3"
                          data-bs-original-title="Theme-3"
                        >
                          <svg
                            className="customizer-btn"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={26}
                            height={26}
                          >
                            <circle cx={12} cy={12} r={10} fill="#DB5363" />
                            <path d="M2,12 a1,1 1 1,0 20,0" fill="#366AF0" />
                          </svg>
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="theme-color-yellow"
                          className="btn-check"
                          name="theme_color"
                          id="theme-color-4"
                          data-colors='{"primary": "#EA6A12", "info": "#6410F1"}'
                        />
                        <label
                          className="btn btn-border d-block bg-transparent"
                          htmlFor="theme-color-4"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Theme-4"
                          data-bs-original-title="Theme-4"
                        >
                          <svg
                            className="customizer-btn"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={26}
                            height={26}
                          >
                            <circle cx={12} cy={12} r={10} fill="#EA6A12" />
                            <path d="M2,12 a1,1 1 1,0 20,0" fill="#6410F1" />
                          </svg>
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="theme-color-pink"
                          className="btn-check"
                          name="theme_color"
                          id="theme-color-5"
                          data-colors='{"primary": "#E586B3", "info": "#25C799"}'
                        />
                        <label
                          className="btn btn-border d-block bg-transparent"
                          htmlFor="theme-color-5"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Theme-5"
                          data-bs-original-title="Theme-5"
                        >
                          <svg
                            className="customizer-btn"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={26}
                            height={26}
                          >
                            <circle cx={12} cy={12} r={10} fill="#E586B3" />
                            <path d="M2,12 a1,1 1 1,0 20,0" fill="#25C799" />
                          </svg>
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* Color customizer end here */}
                  <hr className="hr-horizontal" />
                  {/* Menu color start here */}
                  <div>
                    <h6 className="mt-4 mb-3">Menu Color</h6>
                    <div className="d-grid gap-3 grid-cols-3 mb-3">
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="sidebar-white"
                          className="btn-check"
                          name="sidebar_color"
                          id="sidebar-white"
                          defaultChecked=""
                        />
                        <label
                          className="btn btn-border d-flex align-items-center bg-transparent"
                          htmlFor="sidebar-white"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Sidebar White"
                          data-bs-original-title="Sidebar White"
                        >
                          <i className="text-white">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon-18"
                              width={18}
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <circle cx={12} cy={12} r={8} fill="currentColor" stroke="black" strokeWidth={3} />
                            </svg>
                          </i>
                          <span className="ms-2">Default</span>
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="sidebar-dark"
                          className="btn-check"
                          name="sidebar_color"
                          id="sidebar-dark"
                        />
                        <label
                          className="btn btn-border d-flex align-items-center bg-transparent"
                          htmlFor="sidebar-dark"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Sidebar Dark"
                          data-bs-original-title="Sidebar Dark"
                        >
                          <i className="text-dark">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon-18"
                              width={18}
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <circle cx={12} cy={12} r={8} fill="currentColor" />
                            </svg>
                          </i>
                          <span className="ms-2"> Dark </span>
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="sidebar-color"
                          className="btn-check"
                          name="sidebar_color"
                          id="sidebar-color"
                        />
                        <label
                          className="btn btn-border d-flex align-items-center bg-transparent"
                          htmlFor="sidebar-color"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Sidebar Colored"
                          data-bs-original-title="Sidebar Colored"
                        >
                          <i className="text-primary">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon-18"
                              width={18}
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <circle cx={12} cy={12} r={8} fill="currentColor" />
                            </svg>
                          </i>
                          <span className="ms-2"> Color </span>
                        </label>
                      </div>
                    </div>
                    <div className="d-grid gap-3 grid-cols-2 mb-4">
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="sidebar-transparent"
                          className="btn-check"
                          name="sidebar_color"
                          id="sidebar-transparent"
                        />
                        <label
                          className="btn btn-border d-flex align-items-center bg-transparent"
                          htmlFor="sidebar-transparent"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Sidebar Transparent"
                          data-bs-original-title="Sidebar Transparent"
                        >
                          <i className="text-dark">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon-18"
                              width={18}
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <circle cx={12} cy={12} r={8} fill="#F5F6FA" stroke="black" strokeWidth={3} />
                            </svg>
                          </i>
                          <span className="ms-2">Transparent</span>
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="sidebar-glass"
                          className="btn-check"
                          name="sidebar_color"
                          id="sidebar-glass"
                        />
                        <label
                          className="btn btn-border d-flex align-items-center bg-transparent"
                          htmlFor="sidebar-glass"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Sidebar Transparent"
                          data-bs-original-title="Sidebar Transparent"
                        >
                          <i className="text-dark">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon-18"
                              width={18}
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <circle cx={12} cy={12} r={8} fill="#F5F6FA" stroke="black" strokeWidth={3} />
                            </svg>
                          </i>
                          <span className="ms-2">Glass</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* Menu color end here */}
                  <hr className="hr-horizontal" />
                  {/* Menu Style start here */}
                  <div>
                    <h6 className="mt-4 mb-3">Menu Style</h6>
                    <div className="d-grid gap-3 grid-cols-4 mb-4">
                      <div data-setting="checkbox" className="text-center">
                        <input
                          type="checkbox"
                          defaultValue="sidebar-mini"
                          className="btn-check"
                          name="sidebar_type"
                          id="sidebar-mini"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="sidebar-mini">
                          <img
                            src="../assets/images/settings/dark/03.png"
                            alt="mini"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/03.png"
                            alt="mini"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Mini</span>
                      </div>
                      <div data-setting="checkbox" className="text-center">
                        <input
                          type="checkbox"
                          defaultValue="sidebar-hover"
                          data-extra="{target: '.sidebar', ClassListAdd: 'sidebar-mini'}"
                          className="btn-check"
                          name="sidebar_type"
                          id="sidebar-hover"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="sidebar-hover">
                          <img
                            src="../assets/images/settings/dark/04.png"
                            alt="hover"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/04.png"
                            alt="hover"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Hover</span>
                      </div>
                      <div data-setting="checkbox" className="text-center">
                        <input
                          type="checkbox"
                          defaultValue="sidebar-boxed"
                          className="btn-check"
                          name="sidebar_type"
                          id="sidebar-boxed"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="sidebar-boxed">
                          <img
                            src="../assets/images/settings/dark/05.png"
                            alt="boxed"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/05.png"
                            alt="boxed"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Boxed</span>
                      </div>
                      <div data-setting="checkbox" className="text-center">
                        <input
                          type="checkbox"
                          defaultValue="sidebar-soft"
                          className="btn-check"
                          name="sidebar_type"
                          id="sidebar-soft"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="sidebar-soft">
                          <img
                            src="../assets/images/settings/dark/05.png"
                            alt="boxed"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/05.png"
                            alt="boxed"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Soft</span>
                      </div>
                    </div>
                  </div>
                  {/* Menu Style end here */}
                  <hr className="hr-horizontal" />
                  {/* Active Menu Style start here */}
                  <div>
                    <h6 className="mt-4 mb-3">Active Menu Style</h6>
                    <div className="d-grid gap-3 grid-cols-3 mb-4">
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="sidebar-default navs-rounded"
                          className="btn-check"
                          name="sidebar_menu_style"
                          id="navs-rounded"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="navs-rounded">
                          <img
                            src="../assets/images/settings/dark/06.png"
                            alt="mini"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/06.png"
                            alt="mini"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Rounded One Side</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="sidebar-default navs-rounded-all"
                          className="btn-check"
                          name="sidebar_menu_style"
                          id="navs-rounded-all"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="navs-rounded-all">
                          <img
                            src="../assets/images/settings/dark/07.png"
                            alt="hover"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/07.png"
                            alt="hover"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Rounded All</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="sidebar-default navs-pill"
                          className="btn-check"
                          name="sidebar_menu_style"
                          id="navs-pill"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="navs-pill">
                          <img
                            src="../assets/images/settings/dark/08.png"
                            alt="boxed"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/08.png"
                            alt="boxed"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Pill One Side</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="sidebar-default navs-pill-all"
                          className="btn-check"
                          name="sidebar_menu_style"
                          id="navs-pill-all"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="navs-pill-all">
                          <img
                            src="../assets/images/settings/dark/09.png"
                            alt="boxed"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/09.png"
                            alt="boxed"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Pill All</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="left-bordered"
                          className="btn-check"
                          name="sidebar_menu_style"
                          id="left-bordered"
                          defaultChecked=""
                        />
                        <label
                          className="btn btn-border position-relative p-0 d-block overflow-hidden"
                          htmlFor="left-bordered"
                        >
                          <img
                            src="../assets/images/settings/dark/14.png"
                            alt="boxed"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/14.png"
                            alt="boxed"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <small className="badge bg-danger position-absolute top-1 end-0 m-2">Pro</small>
                        </label>
                        <span className="mt-2">Left Bordered</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="sidebar-default navs-full-width"
                          className="btn-check"
                          name="sidebar_menu_style"
                          id="navs-full-width"
                        />
                        <label
                          className="btn btn-border position-relative p-0 d-block overflow-hidden"
                          htmlFor="navs-full-width"
                        >
                          <img
                            src="../assets/images/settings/dark/15.png"
                            alt="boxed"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/15.png"
                            alt="boxed"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <small className="badge bg-danger position-absolute top-1 end-0 m-2">Pro</small>
                        </label>
                        <span className="mt-2">Full Width</span>
                      </div>
                    </div>
                  </div>
                  {/* Active Menu Style end here */}
                  <hr className="hr-horizontal" />
                  {/* Navbar style start here */}
                  <div>
                    <h6 className="mt-4 mb-3">Navbar Style</h6>
                    <div className="d-grid gap-3 grid-cols-4 mb-4">
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="nav-glass"
                          className="btn-check"
                          name="header_navbar"
                          id="nav-glass"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="nav-glass">
                          <img
                            src="../assets/images/settings/dark/10.png"
                            alt="hover"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/10.png"
                            alt="hover"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Glass</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="navs-sticky"
                          className="btn-check"
                          name="header_navbar"
                          id="navs-sticky"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="navs-sticky">
                          <img
                            src="../assets/images/settings/dark/04.png"
                            alt="hover"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/04.png"
                            alt="hover"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Sticky</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="navs-transparent"
                          className="btn-check"
                          name="header_navbar"
                          id="navs-transparent"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="navs-transparent">
                          <img
                            src="../assets/images/settings/dark/12.png"
                            alt="boxed"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/12.png"
                            alt="boxed"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Transparent</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="navs-default"
                          className="btn-check"
                          name="header_navbar"
                          id="navs-default"
                          defaultChecked=""
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="navs-default">
                          <img
                            src="../assets/images/settings/dark/01.png"
                            alt="default"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/01.png"
                            alt="default"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Default</span>
                      </div>
                    </div>
                  </div>
                  {/* Navbar style end here */}
                  <hr className="hr-horizontal" />
                  {/* Card style start here */}
                  <div className="mb-4">
                    <div className="mt-4 mb-3">
                      <h6 className="d-inline-block mb-0 me-2">Card Style</h6>
                      <small className="badge bg-warning rounded-pill">Pro</small>
                    </div>
                    <div className="d-grid gap-3 grid-cols-2 mb-3">
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="card-default"
                          className="btn-check"
                          name="card_color"
                          id="card-default"
                          defaultChecked=""
                        />
                        <label
                          className="btn btn-border d-block"
                          htmlFor="card-default"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Card White"
                          data-bs-original-title="Card White"
                        >
                          <span>Default Style</span>
                        </label>
                      </div>
                      <div data-setting="radio">
                        <input
                          type="radio"
                          defaultValue="card-glass"
                          className="btn-check"
                          name="card_color"
                          id="card-glass"
                        />
                        <label
                          className="btn btn-border d-block"
                          htmlFor="card-glass"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Card Glass"
                          data-bs-original-title="Card Glass"
                        >
                          <span>Glass Effect</span>
                        </label>
                      </div>
                    </div>
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="card-transparent"
                        className="btn-check"
                        name="card_color"
                        id="card-transparent"
                      />
                      <label
                        className="btn btn-border d-block"
                        htmlFor="card-transparent"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Card Transparent"
                        data-bs-original-title="Card Transparent"
                      >
                        <span>Transparent Style</span>
                      </label>
                    </div>
                  </div>
                  {/* Card style end here */}
                  <hr className="hr-horizontal" />
                  {/* Banner style start here */}
                  <div>
                    <h6 className="mt-4 mb-3">Banner Style</h6>
                    <div className="d-grid gap-3 grid-cols-3 mb-4">
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="navs-bg-color"
                          className="btn-check"
                          name="header_banner"
                          id="header-banner-color"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="header-banner-color">
                          <img
                            src="../assets/images/settings/dark/11.png"
                            alt="hover"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/11.png"
                            alt="hover"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Color</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="default"
                          className="btn-check"
                          name="header_banner"
                          id="header-banner-default"
                        />
                        <label className="btn btn-border p-0 d-block overflow-hidden" htmlFor="header-banner-default">
                          <img
                            src="../assets/images/settings/dark/04.png"
                            alt="hover"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/04.png"
                            alt="hover"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                        </label>
                        <span className="mt-2">Image</span>
                      </div>
                      <div data-setting="radio" className="text-center">
                        <input
                          type="radio"
                          defaultValue="hide"
                          className="btn-check"
                          name="header_banner"
                          id="hide-banner"
                          defaultChecked=""
                        />
                        <label
                          className="btn btn-border position-relative p-0 d-block overflow-hidden"
                          htmlFor="hide-banner"
                        >
                          <img
                            src="../assets/images/settings/dark/05.png"
                            alt="boxed"
                            className="mode dark-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <img
                            src="../assets/images/settings/light/05.png"
                            alt="boxed"
                            className="mode light-img img-fluid"
                            width={200}
                            height={200}
                            loading="lazy"
                          />
                          <small className="badge bg-danger position-absolute top-1 end-0 m-2">Pro</small>
                        </label>
                        <span className="mt-2">Hide</span>
                      </div>
                    </div>
                  </div>
                  {/* Banner style end here */}
                  <hr className="hr-horizontal" />
                  {/* Page Animation start here */}
                  <div className="mt-4 mb-3">
                    <h6 className="d-inline-block mb-0 me-2">Footer</h6>
                    <small className="badge bg-warning rounded-pill">Pro</small>
                  </div>
                  <div className="d-grid gap-3 grid-cols-3 mb-4">
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="default"
                        className="btn-check"
                        name="footer"
                        id="footer_default"
                        defaultChecked=""
                      />
                      <label className="btn btn-border d-block" htmlFor="footer_default">
                        Default
                      </label>
                    </div>
                    <div data-setting="radio">
                      <input type="radio" defaultValue="sticky" className="btn-check" name="footer" id="footer_Sticky" />
                      <label className="btn btn-border d-block" htmlFor="footer_Sticky">
                        Sticky
                      </label>
                    </div>
                    <div data-setting="radio">
                      <input type="radio" defaultValue="glass" className="btn-check" name="footer" id="footer_glass" />
                      <label className="btn btn-border d-block" htmlFor="footer_glass">
                        Glass
                      </label>
                    </div>
                  </div>
                  {/* Page Animation start here */}
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="border border-2 rounded">
                <div className="px-3 pt-3 d-flex align-items-center justify-content-center gap-2">
                  <h5 className="mb-0">Advanced</h5>
                  <span className="badge rounded-pill bg-warning">Pro</span>
                </div>
                <div className="p-3">
                  <h6 className="mb-3 d-inline-block">App Name</h6>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Edit the App Name with your business name to familiarize your audience. "
                  >
                    <svg
                      className="icon-20"
                      width={20}
                      height={20}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </span>
                  <div className="d-grid gap-3 grid-cols-1 mb-4">
                    <div className="form-group mb-0">
                      <input
                        type="text"
                        data-setting="input"
                        maxLength={10}
                        name="app_name"
                        className="form-control"
                        defaultValue=""
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <h6 className="d-inline-block">Font</h6>
                    <a href="javascript:void(0)" data-reset="body-heading-font">
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M21.4799 12.2424C21.7557 12.2326 21.9886 12.4482 21.9852 12.7241C21.9595 14.8075 21.2975 16.8392 20.0799 18.5506C18.7652 20.3986 16.8748 21.7718 14.6964 22.4612C12.518 23.1505 10.1711 23.1183 8.01299 22.3694C5.85488 21.6205 4.00382 20.196 2.74167 18.3126C1.47952 16.4293 0.875433 14.1905 1.02139 11.937C1.16734 9.68346 2.05534 7.53876 3.55018 5.82945C5.04501 4.12014 7.06478 2.93987 9.30193 2.46835C11.5391 1.99683 13.8711 2.2599 15.9428 3.2175L16.7558 1.91838C16.9822 1.55679 17.5282 1.62643 17.6565 2.03324L18.8635 5.85986C18.945 6.11851 18.8055 6.39505 18.549 6.48314L14.6564 7.82007C14.2314 7.96603 13.8445 7.52091 14.0483 7.12042L14.6828 5.87345C13.1977 5.18699 11.526 4.9984 9.92231 5.33642C8.31859 5.67443 6.8707 6.52052 5.79911 7.74586C4.72753 8.97119 4.09095 10.5086 3.98633 12.1241C3.8817 13.7395 4.31474 15.3445 5.21953 16.6945C6.12431 18.0446 7.45126 19.0658 8.99832 19.6027C10.5454 20.1395 12.2278 20.1626 13.7894 19.6684C15.351 19.1743 16.7062 18.1899 17.6486 16.8652C18.4937 15.6773 18.9654 14.2742 19.0113 12.8307C19.0201 12.5545 19.2341 12.3223 19.5103 12.3125L21.4799 12.2424Z"
                          fill="currentColor"
                        />
                        <path
                          d="M20.0941 18.5594C21.3117 16.848 21.9736 14.8163 21.9993 12.7329C22.0027 12.4569 21.7699 12.2413 21.4941 12.2512L19.5244 12.3213C19.2482 12.3311 19.0342 12.5633 19.0254 12.8395C18.9796 14.283 18.5078 15.6861 17.6628 16.8739C16.7203 18.1986 15.3651 19.183 13.8035 19.6772C12.2419 20.1714 10.5595 20.1483 9.01246 19.6114C7.4654 19.0746 6.13845 18.0534 5.23367 16.7033C4.66562 15.8557 4.28352 14.9076 4.10367 13.9196C4.00935 18.0934 6.49194 21.37 10.008 22.6416C10.697 22.8908 11.4336 22.9852 12.1652 22.9465C13.075 22.8983 13.8508 22.742 14.7105 22.4699C16.8889 21.7805 18.7794 20.4073 20.0941 18.5594Z"
                          fill="currentColor"
                        />
                      </svg>
                    </a>
                  </div>
                  <div className="d-grid gap-3 grid-cols-2 mb-4">
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="label">
                          <label className="mb-0 d-inline-block">Body Font</label>
                        </div>
                      </div>
                      <div className="form-group mb-0">
                        <select name="body_font_family" className="form-control" data-select="font" data-setting="select">
                          <option value="">Select Body Font</option>
                        </select>
                      </div>
                    </div>
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="label">
                          <label className="mb-0 d-inline-block">Heading Font</label>
                        </div>
                      </div>
                      <div className="form-group mb-0">
                        <select name="heading_font_family" className="form-control" data-select="font" data-setting="select">
                          <option value="">Select Heading Font</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  {/* Page container start here */}
                  <div>
                    <h6 className="d-inline-block mb-3 me-2">Page Style</h6>
                    <small className="badge bg-warning rounded-pill">Pro</small>
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      title="Wrap your content layout and select Full Width or Boxed styles.  "
                    >
                      <svg
                        className="icon-20"
                        width={20}
                        height={20}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="d-grid gap-3 grid-cols-2 mb-4">
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="container"
                        className="btn-check"
                        name="page_layout"
                        id="page-layout-boxed"
                      />
                      <label className="btn btn-border d-block" htmlFor="page-layout-boxed">
                        Boxed
                      </label>
                    </div>
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="container-fluid"
                        className="btn-check"
                        name="page_layout"
                        id="page-layout-full-width"
                        defaultChecked=""
                      />
                      <label className="btn btn-border d-block" htmlFor="page-layout-full-width">
                        Full Width
                      </label>
                    </div>
                  </div>
                  {/* Page container start here */}
                  {/* Style appearance start here */}
                  <div>
                    <h6 className="d-inline-block mb-3 me-2">Style Appearance</h6>
                    <small className="badge bg-warning rounded-pill">Pro</small>
                  </div>
                  <div className="d-grid gap-3 grid-cols-3 mb-4">
                    <div data-setting="checkbox">
                      <input
                        type="checkbox"
                        defaultValue="theme-flat"
                        className="btn-check"
                        name="theme_style_appearance"
                        id="theme-style-appearance-flat"
                      />
                      <label className="btn btn-border d-block" htmlFor="theme-style-appearance-flat">
                        Flat
                      </label>
                    </div>
                    <div data-setting="checkbox">
                      <input
                        type="checkbox"
                        defaultValue="theme-bordered"
                        className="btn-check"
                        name="theme_style_appearance"
                        id="theme-style-appearance-bordered"
                      />
                      <label className="btn btn-border d-block" htmlFor="theme-style-appearance-bordered">
                        Bordered
                      </label>
                    </div>
                    <div data-setting="checkbox">
                      <input
                        type="checkbox"
                        defaultValue="theme-sharp"
                        className="btn-check"
                        name="theme_style_appearance"
                        id="theme-style-appearance-sharp"
                      />
                      <label className="btn btn-border d-block" htmlFor="theme-style-appearance-sharp">
                        Sharp
                      </label>
                    </div>
                  </div>
                  {/* Style appearance end here */}
                  {/* Page Animation start here */}
                  <div>
                    <h6 className="d-inline-block mb-3 me-2">Page Transition</h6>
                    <small className="badge bg-warning rounded-pill">Pro</small>
                  </div>
                  <div className="d-grid gap-3 grid-cols-2 mb-4">
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="theme-with-animation"
                        className="btn-check"
                        name="theme_transition"
                        id="page-animation"
                        defaultChecked=""
                      />
                      <label className="btn btn-border d-block" htmlFor="page-animation">
                        Animation
                      </label>
                    </div>
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="theme-without-animation"
                        className="btn-check"
                        name="theme_transition"
                        id="without-page-animation"
                      />
                      <label className="btn btn-border d-block" htmlFor="without-page-animation">
                        No Animation
                      </label>
                    </div>
                  </div>
                  {/* Page Animation start here */}
                  <div>
                    <h6 className="mb-3 d-inline-block">Storage</h6>
                    <span
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      title="You can save the setting changes you made for your project on either Local storage, Session storage."
                    >
                      <svg
                        className="icon-20"
                        width={20}
                        height={20}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="d-grid gap-3 grid-cols-3 mb-4">
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="localStorage"
                        className="btn-check"
                        name="saveLocal"
                        id="save-localstorage"
                      />
                      <label className="btn btn-border d-block" htmlFor="save-localstorage">
                        Local
                      </label>
                    </div>
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="sessionStorage"
                        className="btn-check"
                        name="saveLocal"
                        id="save-sessionstorage"
                      />
                      <label className="btn btn-border d-block" htmlFor="save-sessionstorage">
                        Session
                      </label>
                    </div>
                    <div data-setting="radio">
                      <input
                        type="radio"
                        defaultValue="none"
                        className="btn-check"
                        name="saveLocal"
                        id="save-none"
                        defaultChecked=""
                      />
                      <label className="btn btn-border d-block" htmlFor="save-none">
                        None
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Settings sidebar end here */}
      <a
        className="btn btn-fixed-end btn-primary btn-icon btn-setting"
        id="settingbutton"
        data-bs-toggle="offcanvas"
        data-bs-target="#live-customizer"
        role="button"
        aria-controls="live-customizer"
      >
        <svg
          className="icon-24 animated-rotate"
          width={24}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8064 7.62361L20.184 6.54352C19.6574 5.6296 18.4905 5.31432 17.5753 5.83872V5.83872C17.1397 6.09534 16.6198 6.16815 16.1305 6.04109C15.6411 5.91402 15.2224 5.59752 14.9666 5.16137C14.8021 4.88415 14.7137 4.56839 14.7103 4.24604V4.24604C14.7251 3.72922 14.5302 3.2284 14.1698 2.85767C13.8094 2.48694 13.3143 2.27786 12.7973 2.27808H11.5433C11.0367 2.27807 10.5511 2.47991 10.1938 2.83895C9.83644 3.19798 9.63693 3.68459 9.63937 4.19112V4.19112C9.62435 5.23693 8.77224 6.07681 7.72632 6.0767C7.40397 6.07336 7.08821 5.98494 6.81099 5.82041V5.82041C5.89582 5.29601 4.72887 5.61129 4.20229 6.52522L3.5341 7.62361C3.00817 8.53639 3.31916 9.70261 4.22975 10.2323V10.2323C4.82166 10.574 5.18629 11.2056 5.18629 11.8891C5.18629 12.5725 4.82166 13.2041 4.22975 13.5458V13.5458C3.32031 14.0719 3.00898 15.2353 3.5341 16.1454V16.1454L4.16568 17.2346C4.4124 17.6798 4.82636 18.0083 5.31595 18.1474C5.80554 18.2866 6.3304 18.2249 6.77438 17.976V17.976C7.21084 17.7213 7.73094 17.6516 8.2191 17.7822C8.70725 17.9128 9.12299 18.233 9.37392 18.6717C9.53845 18.9489 9.62686 19.2646 9.63021 19.587V19.587C9.63021 20.6435 10.4867 21.5 11.5433 21.5H12.7973C13.8502 21.5001 14.7053 20.6491 14.7103 19.5962V19.5962C14.7079 19.088 14.9086 18.6 15.2679 18.2407C15.6272 17.8814 16.1152 17.6807 16.6233 17.6831C16.9449 17.6917 17.2594 17.7798 17.5387 17.9394V17.9394C18.4515 18.4653 19.6177 18.1544 20.1474 17.2438V17.2438L20.8064 16.1454C21.0615 15.7075 21.1315 15.186 21.001 14.6964C20.8704 14.2067 20.55 13.7894 20.1108 13.5367V13.5367C19.6715 13.284 19.3511 12.8666 19.2206 12.3769C19.09 11.8873 19.16 11.3658 19.4151 10.928C19.581 10.6383 19.8211 10.3982 20.1108 10.2323V10.2323C21.0159 9.70289 21.3262 8.54349 20.8064 7.63277V7.63277V7.62361Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="12.1747"
            cy="11.8891"
            r="2.63616"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </>
  );
}
